import React, { useRef, useEffect } from 'react';

/**
 * ClickContainer is a component that triggers callbacks when users click somewhere on the page
 */
var ClickContainer = function ClickContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    Component = _ref.component,
    id = _ref.id,
    onClickOutside = _ref.onClickOutside,
    onMouseLeave = _ref.onMouseLeave;
  var clickContainerRef = useRef(null);
  useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(function () {
    if (!clickContainerRef.current) {
      return;
    }
    clickContainerRef.current.addEventListener('mouseleave', handleMouseLeft);
  }, [clickContainerRef.current]);
  var handleMouseLeft = function handleMouseLeft() {
    if (typeof onMouseLeave === 'function') {
      onMouseLeave();
    }
  };
  var handleClickOutside = function handleClickOutside(e) {
    var _clickContainerRef$cu;
    if ((clickContainerRef === null || clickContainerRef === void 0 || (_clickContainerRef$cu = clickContainerRef.current) === null || _clickContainerRef$cu === void 0 ? void 0 : _clickContainerRef$cu.contains(e.target)) === false && typeof onClickOutside === 'function') {
      onClickOutside();
    }
  };
  var handleSetClickContainerRef = function handleSetClickContainerRef(ref) {
    clickContainerRef.current = ref;
  };
  var Wrapper = Component || 'div';
  return /*#__PURE__*/React.createElement(Wrapper, {
    id: id,
    className: className,
    ref: handleSetClickContainerRef
  }, children);
};
export default ClickContainer;